<template>
  <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="true"
      top="5px"
      class="dialog-big"
      @close="closeForm">
    <div slot="title">
      <span class="el-dialog__title">
        {{ $t('common.one_off') }}
      </span>
    </div>
    <div v-loading="submitting">
      <el-steps
          :active="active"
          finish-status="success"
          align-center>
        <el-step
            title="Customer"
            description="Details" />
        <el-step
            title="Product"
            description="Details" />
        <el-step
            title="Extra"
            description="Information" />
        <el-step
            title="Review"
            description="Before submit" />
        <el-step
            title="Summary"
            description="request" />
      </el-steps>
      <div class="step-content">
        <div v-if="active === 0">
          <customer-request-customer-step
              v-if="visible"
              ref="customerStep"
              @next="nextStep(1)" />
        </div>
        <div v-if="active === 1">
          <customer-request-product-step
              @back="backStep(0)"
              @next="nextStep(2)" />
        </div>
        <div v-if="active === 2">
          <customer-request-misc-step
              @back="backStep(1)"
              @next="nextStep(3)" />
        </div>
        <div v-if="active === 3">
          <customer-request-review-step
              @back="backStep(2)"
              @submit="submit()" />
        </div>
        <div v-if="active === 4">
          <el-row :gutter="20">
            <el-col :span="12">
              <h4 class="request-panel-title">
                Request
              </h4>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Request ID</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.uuid }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>State</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.state }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Product</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.product.description }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Agent</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.agent.email }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Reasons</b>
                </el-col>
                <el-col :span="18">
                  <ul class="reasons-resume">
                    <li
                        v-for="rr in newRequest.request_reasons"
                        :key="rr.reason.id || rr.reason.table.reason_id"
                        class="reason-row">
                      {{ rr.reason.text || rr.reason.table.text }}
                    </li>
                  </ul>
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Created</b>
                </el-col>
                <el-col :span="18">
                  <time-zone-formatter :current-time="newRequest.created_at" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <h4 class="request-panel-title">
                Customer
              </h4>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Name</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.customer_name }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Email</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.customer_email }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Phone</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.customer_phone }}
                </el-col>
              </el-row>
              <el-row
                  class="form-row"
                  :gutter="20">
                <el-col :span="6">
                  <b>Address</b>
                </el-col>
                <el-col :span="18">
                  {{ newRequest.customer_address_1 }},
                  <span v-if="newRequest.customer_address_2">{{ newRequest.customer_address_2 }},</span>
                  {{ newRequest.customer_city }}
                  <br>
                  {{ newRequest.customer_zip }},
                  {{ newRequest.customer_state }},
                  {{ newRequest.customer_country }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="center-buttons">
            <el-button
                type="success"
                @click="closeForm()">
              Finish
            </el-button>
            <el-button
                type="primary"
                @click="showCopyModal()">
              Copy Request Information
            </el-button>
          </div>
          <CustomerRequestCopyData
              ref="copyRequestModal"
              :request="newRequest" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import CustomerRequestCustomerStep from "./CustomerRequestComponents/CustomerRequestCustomerStep";
import CustomerRequestProductStep from "./CustomerRequestComponents/CustomerRequestProductStep";
import CustomerRequestMiscStep from "./CustomerRequestComponents/CustomerRequestMiscStep";
import CustomerRequestReviewStep from "./CustomerRequestComponents/CustomerRequestReviewStep";
import CustomerRequestCopyData from "./CustomerRequestComponents/CustomerRequestCopy";

import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: authGetters } = h("auth");
const { mapActions: requestActions, mapGetters: requestGetters } =
  h("db/requests");
import { get, extend } from "lodash";

export default {
  name: "OneOffModalForm",
  components: {
    CustomerRequestCustomerStep,
    CustomerRequestProductStep,
    CustomerRequestMiscStep,
    CustomerRequestReviewStep,
    CustomerRequestCopyData,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: 0,
      submitting: false,
      visible: false,
      newRequest: {
        agent: {},
        product: {},
        reasons: [],
      },
      request: {
        type: "one_off",
        requester: null,
      },
    };
  },
  computed: {
    ...authGetters(["user"]),
    ...requestGetters(["requestInProgress"]),
  },
  methods: {
    ...requestActions([
      "createRequest",
      "resetRequestInProgress",
      "setGeneralData",
      "setCustomerInformation",
      "setAddressInformation",
      "setProductInformation",
      "setReasonInformation",
      "setMiscInformation",
    ]),
    closeForm() {
      this.visible = false;
      this.resetRequestInProgress();
      this.active = 0;
    },
    openForm() {
      this.visible = true;
      this.parseDataFromStore();
    },
    parseDataFromStore() {
      this.request.requester = this.user;
      this.setGeneralData(this.request);
    },
    nextStep(step) {
      this.active = step || this.active + 1;
    },
    backStep(step) {
      this.active = step || this.active - 1;
    },
    showCopyModal() {
      this.$refs.copyRequestModal.openModal();
    },
    submit() {
      this.submitting = true;
      let payload = this.createPayload();
      this.createRequest(payload)
        .then((response) => {
          this.newRequest = response.data;
          this.submitting = false;
          this.nextStep(4);
        })
        .catch((error) => {
          this.$forEachPlcError(error, (msg) => {
            this.$notify({ type: "error", message: msg });
          });
          this.submitting = false;
          this.done = false;
        });
    },
    createPayload() {
      let temp = {};
      extend(temp, this.requestInProgress.customer);
      extend(temp, this.requestInProgress.address);
      extend(temp, this.requestInProgress.misc);
      extend(temp, this.requestInProgress.product);
      extend(temp, {
        customer_request_reasons_attributes:
          this.requestInProgress.reasons.reasons.map((reason) => {
            return {
              reason_id: reason.id,
              quantity: reason.quantity,
            };
          }),
      });
      extend(temp, {
        type: "CustomerRequest::OneOff",
        admin_user_id: this.user.id,
        requested_by_area: "customer_support",
      });
      return temp;
    },
  },
};
</script>

<style lang="css">
.center-text {
  text-align: center;
}
.center-buttons {
  margin: 20px 0px 10px 0px;
  text-align: center;
}
.step-content {
  margin-top: 20px;
  margin-bottom: 20px;
  word-break: break-word;
}
.el-steps--horizontal {
  background: #f9f9f9;
  padding: 10px 5px;
  margin-bottom: 20px;
}
.reset-button {
  font-size: 12px;
  font-weight: 200;
  color: #999;
}
.confirm-text {
  font-size: 15px !important;
  margin: 5px 10px;
}
.el-row.form-row {
  margin-bottom: 15px;
}
ul.reasons-resume {
  margin: 0px;
  padding: 0px;
  list-style-type: none;
}
ul.reasons-resume li.reason-row {
  margin: 0px !important;
  padding: 0px !important;
  float: none !important;
}
</style>
